import styled from "styled-components";

export const Fieldset = styled.fieldset`
  margin-bottom: 32px;
`;

export const Label = styled.label`
  font-weight: bold;
`;
